import { render, staticRenderFns } from "./SithMesPrdLearningEdit.vue?vue&type=template&id=8b596568&"
import script from "./SithMesPrdLearningEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdLearningEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports